import { gql } from '@apollo/client'

export default gql`
  fragment patient on Patient {
    id
    uuid
    date_of_birth
    minor
    email
    first_name
    last_name
    gender
    phone_country_code
    phone_number
    address_post_code
    address_state_code
    promotion {
      appointment_count
      code
      description
      duration
      expires_on
      id
      logo
      name
      percent_off
    }
    region {
      id
      iso_code
      age_of_consent
      default_phone_country_code
      support_number
    }
    registration_code {
      code
      consumer_network {
        uuid
        name
      }
    }
  }
`
